module.exports = {"version":"eosio::abi/1.0","types":[],"structs":[{"name":"nonce","base":"","fields":[{"name":"value","type":"string"}]}],"actions":[{"name":"nonce","type":"nonce","ricardian_contract":""}],"tables":[],"ricardian_clauses":[],"abi_extensions":[]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/eosjs/lib/schema/eosio.null.abi.json
// module id = OPeQ
// module chunks = 1